import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function CaroPage() {
  const location = getLocationById('caro');
  if (!location) {
    return <div data-id="element-787">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-788">
      <Header data-id="element-789" />

      <main className="pt-20" data-id="element-790">
        <LocationPageHero location={location} data-id="element-791" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-792" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-793" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-794" />
      </main>

      <Footer data-id="element-795" />
    </div>;
}